<template lang="pug">
  SspLayout(area="tnt")
    .form-horizontal
      .row
        .col-md-2
        .col-md-3
          .btn-group
            button.btn.btn-default(v-for="(rb, index) in rangeButtons" :class="{ active: activeIndex === index }" @click="activeIndex = index; filter.range=rb.range") {{rb.text}}
        .col-md-1.text-right
          label.control-label(for="startDate") Start:
        .col-md-2
          p.input-group
            Datepicker(v-model="filter.startDate")
        .col-md-1.text-right
          label.control-label(for="endDate") End:
        .col-md-2
          p.input-group
            Datepicker(v-model="filter.endDate")
      .row
        .sidebar.col-md-2
          ul.navigation
            li.navigation-items.clickable(v-for="(tab, index) in tabNavigation" :class="{active: activeTab === index}")
              a(@click="activeTab = index") {{tab.title}}
        .col-md-10
          component(:is="tabNavigation[activeTab].component" :filter="filter")
</template>

<script>
import Datepicker from '@/components/common/Datepicker'
import TrackingMap from './components/TrackingMap'
import CodesProduced from './components/CodesProduced'
import LastEvents from './components/LastEvents'
import Uploaded from './components/Uploaded'

export default {
  data: () => ({
    activeIndex: 0,
    rangeButtons: [
      { text: 'Week', range: 'week' },
      { text: 'Month', range: 'month' },
      { text: 'Year', range: 'year' }
    ],
    filter: {
      range: '',
      startDate: null,
      endDate: null
    },
    tabNavigation: [{
      title: 'Tracking Map',
      component: TrackingMap
    }, {
      title: 'Codes produced',
      component: CodesProduced
    }, {
      title: 'Last events',
      component: LastEvents
    }, {
      title: 'Uploaded',
      component: Uploaded
    }],
    activeTab: 0
  }),
  created() {
    this.filter.range = 'week'
  },
  watch: {
    filter: {
      handler() {
        let firstDay
        let lastDay
        if (this.filter.range === 'week') {
          firstDay = new Date()
          lastDay = new Date()
          firstDay.setDate(lastDay.getDate() - 7)
          this.filter.startDate = firstDay
          this.filter.endDate = lastDay
        } else if (this.filter.range === 'month') {
          lastDay = new Date();
          firstDay = new Date();
          firstDay.setMonth(lastDay.getMonth() - 1);
          this.filter.startDate = firstDay
          this.filter.endDate = lastDay
        } else if (this.filter.range === 'year') {
          lastDay = new Date();
          firstDay = new Date();
          firstDay.setYear(firstDay.getFullYear() - 1);
          this.filter.startDate = firstDay
          this.filter.endDate = lastDay
        }
        this.filter.range = null
      },
      deep: true
    },
  },
  components: {
    Datepicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/SupplyChainOverview.vue